<template>
  <v-container fluid class="pa-0">

    <Titulo></Titulo>

    <br v-if="screen < 800">

    <v-stepper v-model="e1" elevation="0" :class="Vstep">
      <div :class="Vflex">
        <NavBar v-if="loadMounted == true" :step="3" :typePlan="userData.typePlan"></NavBar>
        <v-stepper-header>
          <div class="circle-step">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 1" step="1"> Inicio
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 2" step="2"> Planes
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 4" step="4"> DPS
            </v-stepper-step>
          </div>
          <v-divider></v-divider>
          <div class="circle-step2">
            <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 12"
              step="5">Datos</v-stepper-step>
          </div>
        </v-stepper-header>
      </div>

      <v-stepper-items>

        <v-stepper-content step="10">
          <v-form ref="form" v-model="valid">
            <v-container style="justify-content: center; display: flex; flex-direction: column; align-items: center;">
              <div class="form-container">
                <v-col :class="vista">

                  <br>
                  <br>

                  <br v-if="screen > 800">
                  <br v-if="screen > 800">

                  <label style="width: 100%;">
                    <h3 :class="labelTitulo" class="text-center">
                      {{ capitalizeName(userData.name) }}, lamentablemente no podemos continuar con el proceso.
                  </h3>

                  <br>
                  
                    <h3 v-if="userData.typePlan == 'Individual'" :class="labelnoSubExcelente" class="text-center">
                      <b>Debido a la condición de salud que declaraste, en este momento no podemos asegurarte. <br>
                      Si tienes dudas o deseas contactarte con nosotros, por favor haz clic aquí.</b>
                    </h3>

                    <h3 v-if="userData.typePlan != 'Individual'" :class="labelnoSubExcelente" class="text-center">
                      <b>Debido a la condición de salud que declaraste, en este momento no podemos asegurar a tu grupo familiar. </b>
                    </h3>

                    <!-- <h3 v-if="userData.typePlan != 'Individual'" :class="labelnoSubExcelente" class="text-center"> -->
                    <div v-if="userData.typePlan != 'Individual'">
                      <h3  :class="labelnoSubExcelente" class="text-center">
                        <b>Si alguno de tus familiares no cumple con los requisitos para estar asegurado, puedes eliminarlo de tu carga familiar para continuar con tu contratación. </b>
                      </h3>
                      <div class="button-container">
                        <v-btn
                          class="button-desing" style="background-color: #4F74E3 !important; color: white; border-radius: 12px; width: 300px; margin-bottom: 10%;" @click="retorno();">
                          Editar Familiares
                        </v-btn>
                      </div>
                      <h3 v-if="userData.typePlan == 'Individual'" :class="labelnoSubExcelente" class="text-center" style="margin-top: 16%;margin-bottom: -26%;">
                        <b>Si tienes dudas o deseas contactarte con nosotros, por favor haz clic aquí.</b>
                      </h3>
                    </div>


                 </label>

                  <br v-if="screen < 800">

                  <div class="button-container">

                    <v-btn
                      class="button-desing" style="background-color: #2D387C; color: white; border-radius: 12px; width: 300px;">
                      Llamar al 800 391 300
                    </v-btn>
                    

                  </div>
                </v-col>
              </div>
            </v-container>
          </v-form>
        </v-stepper-content>

      </v-stepper-items>
    </v-stepper>

  </v-container>
</template>
  
<script>

import Titulo from "./Titulo.vue"
import NavBar from "@/components/NavBar.vue";
import CryptoJS from 'crypto-js';


export default {
  name: "Step4",
  components: { Titulo, NavBar },
  data: () => ({
    secretKey: process.env.VUE_APP_CRYPT,
    loadMounted: false,
    userData: {
      name: null,
      typePlan: null,
      questionOne: null,
      questionTwo: null,
      questionThree: null,
    },
    planData: {
      planOutDesc: null,
      setDesc: false,
      valueDesc: 0,
      couponId: null,
      plan: null,
    },
    valid: false,
    stepperColor: '#4F74E3',
    screen: window.screen.width,
    stepId: null,
    labelTitulo: null,
    labelnoSubExcelente: null,
    components: { Titulo },
    e1: 10,
    Vstep: '',
    Vflex: '',
    questionRules: [(v) => !!v || "Debe seleccionar una opción"],
  }),
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    document.body.setAttribute('data-sku', 'ONC-007-DPF');

    const userDataAux = sessionStorage.getItem('userData');
    const planDataAux = sessionStorage.getItem('planData');

    if (userDataAux) {
      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
    //  console.log("userData: ", this.userData);
    } 
    if (planDataAux){
      const bytesPlanData = CryptoJS.AES.decrypt(planDataAux, this.secretKey);
      const decryptedDataPlan = bytesPlanData.toString(CryptoJS.enc.Utf8);
      this.planData = JSON.parse(decryptedDataPlan);
      // console.log("planData: ", this.planData);
    }

    this.userData.questionOne = sessionStorage.getItem('QOne')
    this.userData.questionTwo = sessionStorage.getItem('QTwo')
    this.userData.questionThree = sessionStorage.getItem('QThree')
    
    if (this.screen > 800) {
      this.vista = 'vista2';
      this.labelTitulo = 'labelTitulo';
      this.labelnoSubExcelente = 'labelnoSubExcelente';
      this.Vstep = 'VstepDesktop';
      this.Vflex = 'VflexDesktop';
    } else {
      this.vista = 'vista';
      this.labelTitulo = 'labelTitulo2';
      this.labelnoSubExcelente = 'labelnoSubExcelente2';
      this.Vflex = 'VflexMobile';
    }
    this.loadMounted = true;
  },
  methods: {
    back() {
      this.$router.push({ path: '/og/dps' })
    },
    capitalizeName(name) {
            if (!name) return '';
            return name.charAt(0).toUpperCase() + name.slice(1);
    },
    retorno(){
      this.$router.push({ path: '/og/planes' })
    },
    validate() {
      sessionStorage.setItem('QOne', this.userData.name)
      sessionStorage.setItem('QOne', this.userData.questionOne)
      sessionStorage.setItem('QTwo', this.userData.questionTwo)
      sessionStorage.setItem('QThree', this.userData.questionThree)
      if (this.userData.typePlan == 'Individual') {
        this.$router.push({ path: '/og/datos-contratante' })
      } else {
        this.$router.push({ path: '/og/datos-beneficiarios' })
      }
    },
    volverAgregar() {
      if (this.userData.typePlan == 'Individual') {
        this.$router.push({ path: '/og/planes' })
      } else {
        this.$router.push({ path: '/og/beneficiarios' })
      }
    }
  }
};

</script>
  
<style lang="scss">
.VstepDesktop {
  margin-top: -0.3%
}

.VflexDesktop {
    background-color: rgb(247, 247, 247);
    display: flex;
    margin: auto;
    height: 50px;
}

.VflexMobile {
    background-color: rgb(247, 247, 247);
    display: flex;
    margin: auto;
    height: 30px;
    margin-top: -2.3%;
    margin-bottom: 2.3%
}

.labelNumLlamar {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 50px;
  // top: 175px;
  text-align: center;
}

.labelSuperior {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: justify;
  color: #232323;
  opacity: 0.75;
  height: 103px;
}

.labelTitulo {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.01em;
  color: #2D387C;
}
.labelTitulo2 {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.01em;
  color: #2D387C;
  width: 100%;
}

.labelQuestion1 {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  color: #4040CF;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  justify-content: left;
}

.labelTexto {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  text-align: justify;
}

.labelTexto-negrita {
  font-family: Poppins;
  font-style: italic;
  font-weight: bold;
  font-size: 11px;
  line-height: 16px;
  color: #232323;
  height: 138px;
  text-align: justify;
  hyphens: auto;
}

.labelBeneficioss {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 150px;
  text-align: justify;
}

.labelExcelente {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
  margin-top: -5%;
}

.labelSubExcelente {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  text-align: center;
}

.labelNoExcelente {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
  margin-top: -5%;
}

.labelnoSubExcelente {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  text-align: center;
  margin-bottom: -5%;
}
.labelnoSubExcelente2 {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 22px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  text-align: center;
  margin-bottom: -5%;
  width: 118%;
  margin-left: -9%;
}

.vista {
  max-width: 1000px;
}

.vista2 {
  margin-top: -4%;
  min-width: 600px;
}

.step-data {
  max-width: 85%;
  align-items: center;
  // display: flex;
  margin-left: 2rem;
  justify-content: center;

  .v-select {
    max-width: 150px;
  }
}

.form-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 800px;
}

.form-box {
  box-sizing: border-box;
  max-width: 800px;
  background: #F3F3F3;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  border-radius: 6px;
}

.v-input .v-label {
  font-size: 12px;
  color: #8E8E8E;
}

h1 {
  font-weight: 500;
  text-align: center;
  color: #464e71;
  margin-bottom: 2rem;
}

h2 {
  font-weight: 500;
  color: #464e71;
  margin-bottom: 1rem;
}

p {
  text-align: center;
}

.back-container {
  width: 100%;
  align-items: flex-start;

  .back-button {


    &:hover {
      opacity: 1;
    }
  }
}

.button-container {
  text-align: center;
}

.forecast-selector {
  text-transform: uppercase;
  font-weight: 600;
  color: #464e71;
}

.v-btn__content {
  padding: 0.75rem;
}

.v-messages__message {
  padding-bottom: 10%;
  text-align: center;
  margin: auto;
}

</style>